import WomenTops from "../components/WomenTops/WomenTops";
import { Link } from "react-router-dom";
function WomenTopsPage() {
  return <WomenTops />;
}

export default WomenTopsPage;